export AddAuctionPage from './AddAuctionPage';
export AppPage from './containers/appPage/AppPage'
export AuctionsPage from './AuctionsPage';
export ConfirmWinnersPage from './ConfirmWinnersPage';
export DonatePage from './containers/donatePage/DonatePage';
export HomePage from './containers/homePage/HomePage';
export LoginPage from './LoginPage';
export ResultsPage from './containers/resultsPage/ResultsPage';
export DonorsPage from './containers/donorsPage/DonorsPage';
export SponsorsPage from './containers/sponsorsPage/SponsorsPage';


/** WEBPACK FOOTER **
 ** ./src/components/index.js
 **/